import React from 'react';
import './errorbox.scss';
import {InformationSquareFillIcon} from '@navikt/aksel-icons';

export const ErrorBox = (props) =>{
  return (
    <section className="errorBox">
      <InformationSquareFillIcon fontSize="3.0rem" />
      <article className="errorText">
        <div>{props.children}</div>
      </article>
    </section>
  );
};
